import { render, staticRenderFns } from "./ChatTiModalAccess.vue?vue&type=template&id=3537fce9"
import script from "./ChatTiModalAccess.vue?vue&type=script&lang=js"
export * from "./ChatTiModalAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports